import { Typography } from "@mui/material"
import Modal from "../ui/Modal"

const DeleteConfirm = ({ type, name, ...props }) => {
  return (
    <Modal {...props} title={"Delete " + type} actionText="Delete">
      <Typography>
        Do you want to delete {type} '{name}'? This action is irreversible.
      </Typography>
    </Modal>
  )
}

export default DeleteConfirm
